var get       = require("object-path").get,
    themeVars = require("app/theme/variables");

module.exports = {

    /**
     * The maximum width of repeater children in the visible part of the list.
     *
     * @type  {number}
     * @public
     */
    maxChildWidth: {
        portrait: {
            md: 275,
            lg: 350
        },
        landscape: {
            md: 320,
            lg: 480
        },
        square: {
            md: 275,
            lg: 350
        }
    },

    /**
     * Get the maximum width of repeater children in the visible part of the
     * list, based on form-factor and size.
     *
     * @param   {string}  formFactor  The form-factor
     * @param   {string}  size        The size
     * @return  {number}  The maximum child width
     * @public
     */
    getMaxChildWidth: function(formFactor, size) {
        return get(
            this.maxChildWidth,
            formFactor + "." + size,
            this.maxChildWidth.portrait.md
        );
    },

    /**
     * The minimum amount of columns in the visible part of the list.
     *
     * @type  {number}
     * @public
     */
    minColumns: {
        portrait: {
            md: 3,
            lg: 2
        },
        landscape: {
            md: 2.5,
            lg: 1.25
        },
        square: {
            md: 3,
            lg: 2
        }
    },

    /**
     * Get the minimum amount of columns in the visible part of the list, based
     * on form-factor and size.
     *
     * @param   {string}  formFactor  The form-factor
     * @param   {string}  size        The size
     * @return  {number}  The minimum amount of columns
     * @public
     */
    getMinColumns: function(formFactor, size) {
        return get(
            this.minColumns,
            formFactor + "." + size,
            this.minColumns.portrait.md
        );
    },

    /**
     * The step size with which to increment column count. The 1st value is for
     * small screens, the 2nd for larger screens.
     *
     * @type  {number}
     * @public
     */
    divisionStep: {
        portrait: {
            md: [0.5, 1],
            lg: [0.5, 1]
        },
        landscape: {
            md: [0.25, 0.5],
            lg: [0.25, 0.5]
        },
        square: {
            md: [0.5, 1],
            lg: [0.5, 1]
        }
    },

    /**
     * Sets the step size with which to increment column count, based on
     * form-factor and size.
     *
     * @param    {string}  formFactor  The form-factor
     * @param    {string}  size        The size
     * @returns  {number}  The step size
     * @public
     */
    getDivisionStep: function(formFactor, size) {
        if (themeVars.windowWidth < 480) {
            return get(
                this.divisionStep,
                formFactor + "." + size + ".0",
                this.divisionStep.portrait.md[0]
            );
        }
        else {
            return get(
                this.divisionStep,
                formFactor + "." + size + ".1",
                this.divisionStep.portrait.md[1]
            );
        }
    },

    /**
     * An additional amount of columns to add to the column count. The 1st value
     * is for small screens, the 2nd for larger screens.
     *
     * @type  {number}
     * @public
     */
    divisionOffset: {
        portrait: {
            md: [0, 0.333],
            lg: [0, 0.333]
        },
        landscape: {
            md: [0, 0.333],
            lg: [0, 0.333]
        },
        square: {
            md: [0, 0.333],
            lg: [0, 0.333]
        }
    },

    /**
     * An additional amount of columns to add to the column count, based on
     * form-factor and size.
     *
     * @param    {string}  formFactor  The form-factor
     * @param    {string}  size        The size
     * @returns  {number}  The additional column count
     * @public
     */
    getDivisionOffset: function(formFactor, size) {
        if (themeVars.windowWidth < 480) {
            return get(
                this.divisionOffset,
                formFactor + "." + size + ".0",
                this.divisionOffset.portrait.md[0]
            );
        }
        else {
            return get(
                this.divisionOffset,
                formFactor + "." + size + ".1",
                this.divisionOffset.portrait.md[1]
            );
        }
    }

};
